import angular from 'angular';
import { AgentLike } from './sticky-agent-like.component';
import favouriteService from './../../favourites/service/favourites-service.module';
import captchaService from '../../captcha/captcha.module'
const MODULE_NAME = 'AgentLike';

export default angular.module(MODULE_NAME, [favouriteService, captchaService]).component('agentLike', AgentLike).name;


